module.exports = __webpack_public_path__ + "img/MSU.dd4f7c85.png";